module.exports = __webpack_public_path__ + "static/confetti_arrows-cb597eb220e9eb9345cee824f554a0c0.png";